import { makeStyles } from '../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        '&.disableBackdrop': {
            '& .MuiBackdrop-root': {
                display: 'none !important',
            },
        },
    },
    paper: {
        minHeight: theme.spacing(7),
        minWidth: theme.spacing(75),
        borderRadius: 8,
        boxShadow: theme.shadows[3],
    },
    closeButton: {
        position: 'absolute',
        top: theme.spacing(0.5),
        right: theme.spacing(0.5),
    },
}));
//# sourceMappingURL=Dialog.styles.js.map